export default (task, parameters = null) => (parameters === null ? task : { ...task, ...parameters });
